import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Usuario } from '../models/Usuario';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { ServersService } from './servers.service';
import { HttpCacheService } from './httpcache.service';

@Injectable()
export class PersonaService {
    constructor(private http: HttpCacheService, private servers: ServersService) { }

    getAllByRol(idRol: any, callback: any) {

        return this.http.get(0, this.servers.serverName + '/rol/' + idRol + '/persona', callback);
    }

    getByTelefono(telefono: any, callback: any) {

        return this.http.get(0, this.servers.serverName + '/telefono/' + telefono + '/persona', callback);
    }

    getCasino(callback: any) {

        return this.http.get(0, 'http://casino.atlasonline.co/public/api/casino/games/1', callback);
    }

    getPermisos( callback: any) {

        return this.http.get(0, this.servers.serverName + '/permiso', callback);
    }

    save(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/persona', object, callback);
    }

    saveImage(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/persona/imagen', object, callback);
    }

    saveCliente(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/persona/cliente', object, callback);
    }

    saveRecarga(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/recarga', object, callback);
    }

    getRecargasByFecha(start: any, end: any, callback: any) {
        return this.http.get(30, this.servers.serverName + '/fecha/range/' + start + '/' + end + '/recarga', callback);
    }

    getConductoresServicioByFecha(start: any, end: any, callback: any) {
        return this.http.get(30, this.servers.serverName + '/fecha/range/' + start + '/' + end + '/servicio/conductores', callback);
    }

    getClientesServicioByFecha(start: any, end: any, callback: any) {
        return this.http.get(30, this.servers.serverName + '/fecha/range/' + start + '/' + end + '/servicio/clientes', callback);
    }

    getServiciosGroupEmpresas(start: any, end: any, callback: any) {
        return this.http.get(30, this.servers.serverName + '/fecha/range/' + start + '/' + end + '/servicio/empresa', callback);
    }

    getServiciosGroupConductoresByEmpresa(start: any, end: any, idEmpresa: any, callback: any) {
        return this.http.get(30,
            this.servers.serverName + '/fecha/range/' + start + '/' + end + '/servicio/conductor/empresa/' + idEmpresa,
            callback
            );
    }

    update(object: any, callback: any) {
        return this.http.put(30, this.servers.serverName + '/persona/' + object.id, object, callback);
    }

    updateState(object: any, callback: any) {
        const url = this.servers.serverName + '/persona/update/state/' + object.id;
        return this.http.put(0, url, object, callback);
    }

    saveConfiguraciones(object: any, callback: any) {

        return this.http.post(30, this.servers.serverName + '/configuracion', object, callback);

    }

    saveBarrio(object: any, callback: any) {

        return this.http.post(30, this.servers.serverName + '/barrio', object, callback);

    }

    deleteBarrio(object: any, callback: any) {

        return this.http.post(30, this.servers.serverName + '/delete/barrio', object, callback);

    }

    getConfiguraciones(callback: any) {
        return this.http.get(0, this.servers.serverName + '/configuracion', callback);
    }

    saveServicio(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/servicio', object, callback);
    }

    getConductoresDisponibles(object: any, callback: any) {
                return this.http.get(30,
            this.servers.serverName + '/tiposervicio/' + object.tipoServicio + '/disponibles/' + object.latitud + '/' + object.longitud,
            callback);
    }

    getServiciosBackend(object: any, callback: any) {
        return this.http.get(30, this.servers.serverName + '/servicio/backend/' + object.fecha_ini + '/' + object.fecha_fin, callback);
    }

    getLogServicio(object: any, callback: any) {
        return this.http.get(30, this.servers.serverName + '/servicio/' + object.idServicio + '/log', callback);
    }

    getConductoresByTipoServicio(object: any, callback: any) {
        return this.http.get(30,
            this.servers.serverName + '/tiposervicio/' + object.idTipoServicio + '/disponibles/ ' + object.latitud + '/' + object.longitud,
            callback);
    }

    getConductoresByTipoServicioBackend(object: any, callback: any) {
        return this.http.get(30,
            this.servers.serverName + '/backend/tiposervicio/' +
            object.idTipoServicio + '/disponibles/' + object.latitud + '/' + object.longitud,
            callback);
    }

    getBarrios(callback: any) {
        return this.http.get(30, this.servers.serverName + '/list/barrio', callback);
    }

    cambiarClave(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/usuario/cambiarclave', object, callback);
    }

    cambiarclaveVerificada(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/usuario/cambiarclaveVerificada', object, callback);
    }

    cambiarEstado(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/servicio/update/state', object, callback);
    }

    enviarEmail(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/persona/sendEmail', object, callback);
    }

    verificarEmail(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/persona/verificarEmail', object, callback);
    }

    recuperarClave(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/persona/recuperarClave', object, callback);
    }

    updateToken(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/updatetoken/persona', object, callback);
    }

    reenviarServicio(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/reenviar/servicio', object, callback);
    }

}



// WEBPACK FOOTER //
// ./src/app/servicios/persona.service.ts